import React from 'react';
import PropTypes from 'prop-types';

import {Box, Paper, Stack, Typography, Avatar} from 'views/components';
import {AccessTime as AccessTimeIcon, CalendarToday as CalendarTodayIcon} from 'views/icons';
import {getEventStatusStyles} from 'views/module';

import moment from 'moment-timezone';


const EventTile = (props) => {
  const {event, onActionClick, selected} = props;

  const styles = getEventStatusStyles({event});

  const userTimezone = moment.tz.guess();

  const formatDate = (dateString, eventTimezone) => {
    const dateTime = moment.tz(dateString, eventTimezone).tz(userTimezone);
    return dateTime.format('ddd, MMM D');
  };

  const formatTime = (startTime, endTime, eventTimezone) => {
    const start = moment.tz(startTime, eventTimezone).tz(userTimezone);
    const end = moment.tz(endTime, eventTimezone).tz(userTimezone);
    const userTimezoneAbbr = start.format('z');
    return `${start.format('h:mm A')} - ${end.format('h:mm A')} ${userTimezoneAbbr}`;
  };

  return (
    <Paper
      elevation={selected ? 3 : 1}
      sx={{
        'display': 'flex',
        'overflow': 'hidden',
        'cursor': onActionClick ? 'pointer' : 'default',
        'backgroundColor': selected ? '#f0f0f0' : 'background.paper',
        '&:hover': onActionClick ? {elevation: 2} : {},
        'transition': 'background-color 0.2s',
      }}
      onClick={() => onActionClick && onActionClick('view')}
    >
      <Box
        sx={{
          width: 4,
          backgroundColor: styles.borderColor,
          flexShrink: 0,
        }}
      />
      <Box sx={{flex: 1, p: 2}}>
        <Stack spacing={1}>
          <Box display="flex" justifyContent="space-between" alignItems="flex-start">
            <Box display="flex" alignItems="center" gap={1.5} sx={{flex: 1}}>
              <Avatar
                sx={{width: 60, height: 60, mr: 2, fontWeight: 600}}
                alt={event.caregiverData.caregiverDetail.caregiverName}
              >
                {event.caregiverData.caregiverDetail.caregiverName[0]}
              </Avatar>
              <Box>
                <Typography variant="h6" sx={{fontWeight: 600, mb: 0.5}}>
                  {event.info?.title || 'Untitled Event'}
                </Typography>
                {event.caregiverData?.caregiverDetail && (
                  <Typography variant="body2" color="text.secondary">
                    {event.caregiverData.caregiverDetail.caregiverName || 'Caregiver'}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                px: 1.5,
                py: 0.5,
                borderRadius: 12,
                backgroundColor: styles.background,
                color: styles.textColor,
                fontSize: '0.75rem',
                fontWeight: 500,
                flexShrink: 0,
                ml: 1,
              }}
            >
              {styles.label}
            </Box>
          </Box>
          <Box display="flex" alignItems="center" gap={2}>
            <Box display="flex" alignItems="center" gap={0.5}>
              <CalendarTodayIcon sx={{fontSize: 16, color: 'text.secondary'}} />
              <Typography variant="body2" color="text.secondary">
                {formatDate(event.eventData?.startTime, event.eventData?.timezone)}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={0.5}>
              <AccessTimeIcon sx={{fontSize: 16, color: 'text.secondary'}} />
              <Typography variant="body2" color="text.secondary">
                {formatTime(event.eventData?.startTime, event.eventData?.endTime, event.eventData?.timezone)}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Box>
    </Paper>
  );
};

EventTile.propTypes = {
  event: PropTypes.object.isRequired,
  onActionClick: PropTypes.func,
  selected: PropTypes.bool,
};

export default EventTile;
